import {makeObservable, action, observable} from 'mobx';
import io from 'socket.io-client';
import Cookies from 'js-cookie';

import Utility from '../Utility';
import sharedUtils from '../serverClientShared/sharedUtils';
import Settings from '../settings.json';
import {incomingCallStore} from '../index';

const WEB_SOCKET_ENDPOINT = `wss://${sharedUtils.WEBSOCKET_DOMAIN}.${Settings.webSocketServer}/`;
export const socket = io(WEB_SOCKET_ENDPOINT);

const socketMessageTypeEnum = {
    CALL: 12,
    ACCEPT: 13,
    DECLINE: 14,
};

const socketRoomId = Cookies.get('deviceId_v2');

const countActiveParticipants = (participantsMap) => {
    if (!participantsMap) return 0;
    if (participantsMap instanceof Map) return participantsMap.size;
    return Object.keys(participantsMap).length;
};

const parseIncomingCallPayload = (data) => {
    let room = {};
    try {
        room = data.data ? JSON.parse(data.data) : {};
    } catch (error) {
        console.warn('Failed to parse incoming call room:', error.message);
    }
    return {
        caller: data.Sender || {},
        room,
        activeParticipantCount: countActiveParticipants(room.ParticipantsMap),
    };
};

export class SocketStore {
    constructor() {
        makeObservable(this, {
            isCalling: observable,
            callInterval: observable,
            fakeCallDeviceToInvite: action,
            terminateCall: action,
        });
    }

    isCalling = false;
    callInterval = null;
    subscribedUserId = null;

    terminateCall = () => {
        if (this.callInterval) {
            socket.emit('LeaveRoom', socketRoomId);
            clearInterval(this.callInterval);
            this.callInterval = null;
            if (!this.subscribedUserId) {
                socket.disconnect();
            }
            this.isCalling = false;
        }
    };

    subscribeForIncomingCalls = (userDetails) => {
        if (!userDetails?._id) return;
        if (this.subscribedUserId === userDetails._id) return;
        this.subscribedUserId = userDetails._id;

        if (!socket.connected) {
            socket.connect();
        }
        socket.off('connect', this.handleSocketReconnect);
        socket.on('connect', this.handleSocketReconnect);
        socket.off('RoomMessage', this.handleIncomingRoomMessage);
        socket.on('RoomMessage', this.handleIncomingRoomMessage);
        this.joinIncomingChannels();
    };

    unsubscribeFromIncomingCalls = () => {
        if (!this.subscribedUserId) return;
        this.subscribedUserId = null;
        socket.off('connect', this.handleSocketReconnect);
        socket.off('RoomMessage', this.handleIncomingRoomMessage);
    };

    handleSocketReconnect = () => {
        this.joinIncomingChannels();
    };

    joinIncomingChannels = () => {
        if (!this.subscribedUserId) return;
        socket.emit('JoinRoom', this.subscribedUserId);
        if (socketRoomId) {
            socket.emit('JoinRoom', socketRoomId);
        }
    };

    handleIncomingRoomMessage = (rawData) => {
        try {
            const data = typeof rawData === 'string' ? JSON.parse(rawData) : rawData;
            if (data?.MessageIdRef !== socketMessageTypeEnum.CALL) return;
            const targetedAtMe = data.roomId === this.subscribedUserId || data.roomId === socketRoomId;
            if (!targetedAtMe) return;
            incomingCallStore.showIncomingCall(parseIncomingCallPayload(data));
        } catch (error) {
            console.warn('Failed to handle incoming call message:', error.message);
        }
    };

    respondToCall = (callerDeviceGuid, accepted, responder) => {
        if (!callerDeviceGuid || !socketRoomId) return;
        const response = {
            MessageIdRef: accepted ? socketMessageTypeEnum.ACCEPT : socketMessageTypeEnum.DECLINE,
            Sender: {
                _id: responder?._id,
                Name: responder?.Name,
                LastName: responder?.LastName,
                AvatarBackground: responder?.AvatarBackground,
                UserIcon: responder?.UserIcon,
                DeviceGuid: socketRoomId,
                Email: responder?.Email,
            },
            roomId: callerDeviceGuid,
        };
        socket.emit('RoomMessage', JSON.stringify(response));
    };

    fakeCallDeviceToInvite(room, userDetails, showMessageFnc, translateFunc, userEmailOrId) {
        socket.connect();


        socket.emit("JoinRoom", socketRoomId);


        const sender = {
            _id: userDetails._id,
            Name: userDetails.Name,
            LastName: userDetails.LastName,
            AvatarBackground: userDetails.AvatarBackground,
            UserIcon: userDetails.UserIcon,
            DeviceGuid: socketRoomId
        };

        const callEventData = {
            MessageIdRef: socketMessageTypeEnum.CALL,
            Sender: sender,
            roomId: room.invitedUserId, // the websocket room
        }
        callEventData.data = JSON.stringify({...room, CreatedBy: callEventData.Sender}); // avoid big payload

        this.isCalling = true;
        let counter = 0;
        this.callInterval = setInterval(() => {
            counter++;
            if (counter === 60) {
                showMessageFnc(translateFunc('user') + ' ' + userEmailOrId + ' ' + translateFunc('didNotAnswerAfter', true) + ' 60 ' + translateFunc('seconds', true));
                Utility.sleep(5000).then(() => showMessageFnc(''));
                this.terminateCall();
                return;
            }
            console.log('calling device', counter)
            socket.emit("RoomMessage", JSON.stringify(callEventData));
            const timeLeft = (60 - counter);
            showMessageFnc(`${translateFunc('calling')} ${userEmailOrId} (${timeLeft} ${translateFunc('seconds')})`);
        }, 1000);

        socket.on('RoomMessage', (rawData) => {
            const data = JSON.parse(rawData);
            if ([socketMessageTypeEnum.ACCEPT, socketMessageTypeEnum.DECLINE].includes(data.MessageIdRef) && socketRoomId === data.roomId) {
                if (data.MessageIdRef === socketMessageTypeEnum.DECLINE) {
                    showMessageFnc(translateFunc('user') + ' ' + userEmailOrId + ' ' + translateFunc('declinedYourCall', true));
                    Utility.sleep(5000).then(() => showMessageFnc(''));
                } else {
                    showMessageFnc('');
                }
                this.terminateCall();
            }
        })
    }
}
